module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/cards/weather-card/weather-card.component.scss
// module id = ./src/app/shared/components/cards/weather-card/weather-card.component.scss
// module chunks = main